import { z } from "zod";
import type { TransformDefinition } from "./transforms";

/**
 * string_join — appends strings from left to right (no separator). Distinct
 * from the grammar's `concat`, which flattens arrays for fan-in; this joins
 * strings on the wire.
 */
export const stringJoinTransform = {
  name: "string_join",
  label: "join",
  description:
    "Appends its arguments left to right, with no separator between them.",
  args: z.tuple([z.string(), z.string()]).rest(z.string()),
  variadic: true,
  output: z.string(),
  evaluate: (args) => args.join(""),
} satisfies TransformDefinition;
